import React, { useEffect, useState } from "react";
import { CalendarDays, Mail, Send } from "lucide-react";
import { toast } from "sonner";
import { api, formatApiError } from "../lib/api";

const fmt = (iso) => (iso ? new Date(iso).toLocaleString("pt-BR") : "—");
const fmtD = (d) => (d ? new Date(d + "T00:00:00").toLocaleDateString("pt-BR") : "—");
const COPY = {
  weekly: { title: "Resumo semanal por e-mail", icon: Mail, period: (n) => `semana que será enviada: ${fmtD(n?.from)} → ${fmtD(n?.to)}`, name: "Resumo semanal" },
  daily: { title: "Resumo diário por e-mail", icon: CalendarDays, period: (n) => `dia coberto: ${fmtD(n?.from)} (UTC)`, name: "Resumo diário" },
};

export function SummaryCard({ period = "weekly" }) {
  const C = COPY[period];
  const [info, setInfo] = useState(null);
  const [busy, setBusy] = useState(false);
  const load = () => api.get(`/admin/summary/${period}`).then(({ data }) => setInfo(data)).catch(() => setInfo({ error: true }));
  useEffect(() => { load(); }, [period]); // eslint-disable-line react-hooks/exhaustive-deps
  const send = async () => {
    setBusy(true);
    try {
      const { data } = await api.post(`/admin/summary/${period}/send`);
      toast.success(`${C.name} enviado para ${data.to}`);
      load();
    } catch (e) { toast.error(formatApiError(e.response?.data?.detail) || "Falha ao enviar o resumo"); }
    finally { setBusy(false); }
  };
  if (!info) return null;
  const last = info.history?.[0];
  return (
    <div className="glass flex flex-wrap items-center justify-between gap-4 rounded-2xl p-5" data-testid={`${period}-summary-card`}>
      <div>
        <p className="flex items-center gap-2 font-display text-lg text-xmas-snow"><C.icon className="h-5 w-5 text-xmas-gold" /> {C.title}</p>
        <p className="mt-1 text-xs text-xmas-champagne" data-testid={`${period}-summary-info`}>
          {info.schedule} · para <span className="text-xmas-gold">{info.recipient || "— (SUPPORT_EMAIL não configurado)"}</span> · {C.period(info.next_week)}
        </p>
        <p className="mt-1 text-[11px] text-xmas-slate" data-testid={`${period}-summary-last`}>
          {last ? `Último envio: ${fmt(last.at)} (${last.trigger === "cron" ? "automático" : "manual"}) · ${last.ok ? `${last.totals?.visits ?? 0} visitas · ${last.totals?.demo_starts ?? 0} demos · ${last.totals?.purchases ?? 0} compras` : `falhou: ${last.error}`}` : "Nenhum envio registrado ainda."}
        </p>
      </div>
      <button onClick={send} disabled={busy || !info.recipient} data-testid={`${period}-summary-send`} className="btn-gold inline-flex items-center gap-2 rounded-full px-5 py-2.5 text-xs font-bold uppercase tracking-wider disabled:opacity-50">
        <Send className="h-3.5 w-3.5" /> {busy ? "Enviando…" : "Enviar agora"}
      </button>
    </div>
  );
}

export function WeeklySummaryCard() { return <SummaryCard period="weekly" />; }
